import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, vModelDynamic as _vModelDynamic, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/bot_express_logo.png'


const _hoisted_1 = { class: "font-nunito min-h-screen bg-zinc-900 flex items-center justify-center p-1 sm:p-4 font-sans" }
const _hoisted_2 = { class: "w-full max-w-xl" }
const _hoisted_3 = { class: "bg-white/5 rounded-xl overflow-hidden mb-8 sm:mb-0" }
const _hoisted_4 = { class: "p-6 sm:p-8" }
const _hoisted_5 = { class: "space-y-2" }
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = { class: "space-y-2" }
const _hoisted_8 = { class: "relative" }
const _hoisted_9 = { class: "space-y-2" }
const _hoisted_10 = { class: "relative" }
const _hoisted_11 = { class: "space-y-2" }
const _hoisted_12 = { class: "relative" }
const _hoisted_13 = { class: "space-y-2" }
const _hoisted_14 = { class: "relative" }
const _hoisted_15 = ["type"]
const _hoisted_16 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_17 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_18 = {
  key: 0,
  class: "text-red-500 text-xs mt-1"
}
const _hoisted_19 = { class: "flex items-start" }
const _hoisted_20 = { class: "flex items-center h-5" }
const _hoisted_21 = {
  for: "terms",
  class: "w-5 h-5 border border-zinc-600/50 rounded peer-checked:bg-[#10B981] peer-checked:border-[#10B981] transition-all duration-200 flex items-center justify-center"
}
const _hoisted_22 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "text-white"
}
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "mt-6 text-center" }
const _hoisted_25 = { class: "text-zinc-400 text-sm" }

import { toast } from '@/components/ui/toast'
import { useAuth } from '@/composables/useAuth'
import router from '@/router'
import { Loader2 } from 'lucide-vue-next'
import { ref, computed } from 'vue'
import { vMaska } from "maska/vue"
import Cookies from 'js-cookie'

// Estado do formulário

export default /*@__PURE__*/_defineComponent({
  __name: 'RegisterView',
  setup(__props) {

const isLoading = ref(false)
const { register } = useAuth()
const name = ref('')
const email = ref('')
const document = ref('')
const whatsapp = ref('')
const password = ref('')
// const confirmPassword = ref('')
const showPassword = ref(false)
// const showConfirmPassword = ref(false)
const acceptTerms = ref(false)

const isDisabled = computed(() => 
  !name.value || 
  !email.value ||
  (!document.value && (document.value?.length ?? 0) > 14) ||
  !password.value ||
  password.value.length < 8 ||
  !whatsapp.value || 
  whatsapp.value.length < 16 ||
  !acceptTerms.value
)

// Função de cadastro
const handleRegister = async () => {
  if (isDisabled.value) {
    return
  }
  
  isLoading.value = true

  try {
    await register({
      name: name.value,
      organizationName: name.value,
      document: document.value,
      phoneNumber: whatsapp.value,
      email: email.value,
      password: password.value,
      organizations: true,
      source: Cookies.get('botexpress_source')
    })

    toast({
      title: 'Conta cadastrada com sucesso',
      class: 'bg-green-500 text-white',
      duration: 1500
    })

    router.push({ name: 'home' })
  } catch (error: any) {
    const uniqueCode = error?.response?.data?.errors?.[0]?.uniqueCode
    if (uniqueCode === 'CREATE_USER:USER_ALREADY_EXIST') {
      toast({
        title: 'E-mail já cadastrado',
        description: 'Este e-mail já está em uso. Faça login ou utilize outro e-mail.',
        class: 'bg-red-500 text-white',
        duration: 4000
      })
    } else {
      toast({
        title: 'Erro ao criar conta',
        description: 'Ocorreu um erro inesperado. Tente novamente.',
        class: 'bg-red-500 text-white',
        duration: 4000
      })
    }
  } finally {
    isLoading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[25] || (_cache[25] = _createElementVNode("div", { class: "flex items-center justify-center mb-8" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "Logo",
          class: "h-auto w-[180px] sm:w-[280px]"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "mb-8" }, [
            _createElementVNode("h2", { class: "text-white text-2xl font-bold mb-2 tracking-tight" }, "Criar sua conta"),
            _createElementVNode("p", { class: "text-zinc-300" }, "Preencha os dados abaixo para começar")
          ], -1)),
          _createElementVNode("form", {
            onSubmit: _withModifiers(handleRegister, ["prevent"]),
            class: "space-y-5"
          }, [
            _createElementVNode("div", _hoisted_5, [
              _cache[8] || (_cache[8] = _createElementVNode("label", {
                for: "name",
                class: "block text-sm font-medium text-zinc-200"
              }, "Nome Completo ou Razão Social", -1)),
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  id: "name",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
                  type: "text",
                  required: "",
                  class: "w-full px-4 py-3 bg-white/5 rounded-md text-white placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-[#10B981] focus:border-[#10B981] transition-all duration-200",
                  placeholder: "Seu nome completo"
                }, null, 512), [
                  [_vModelText, name.value]
                ]),
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none" }, [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "18",
                    height: "18",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    class: "text-zinc-500"
                  }, [
                    _createElementVNode("path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" }),
                    _createElementVNode("circle", {
                      cx: "12",
                      cy: "7",
                      r: "4"
                    })
                  ])
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[10] || (_cache[10] = _createElementVNode("label", {
                for: "document",
                class: "block text-sm font-medium text-zinc-200"
              }, "CPF ou CNPJ", -1)),
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  id: "document",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((document).value = $event)),
                  type: "text",
                  required: "",
                  class: "w-full px-4 py-3 bg-white/5 rounded-md text-white placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-[#10B981] focus:border-[#10B981] transition-all duration-200",
                  placeholder: "000.000.000-00"
                }, null, 512), [
                  [_vModelText, document.value],
                  [_unref(vMaska), (document.value?.length ?? 0) <= 14 ? '###.###.###-###' : '##.###.###/####-##']
                ]),
                _cache[9] || (_cache[9] = _createStaticVNode("<div class=\"absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"text-zinc-500\"><rect width=\"18\" height=\"18\" x=\"3\" y=\"3\" rx=\"2\"></rect><path d=\"M3 9h18\"></path><path d=\"M9 21V9\"></path></svg></div>", 1))
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[12] || (_cache[12] = _createElementVNode("label", {
                for: "whatsapp",
                class: "block text-sm font-medium text-zinc-200"
              }, "WhatsApp", -1)),
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  id: "whatsapp",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((whatsapp).value = $event)),
                  type: "text",
                  required: "",
                  class: "w-full px-4 py-3 bg-white/5 rounded-md text-white placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-[#10B981] focus:border-[#10B981] transition-all duration-200",
                  placeholder: "(00) 00000-0000"
                }, null, 512), [
                  [_vModelText, whatsapp.value],
                  [_unref(vMaska), '(##) # ####-####']
                ]),
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none" }, [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "18",
                    height: "18",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    class: "text-zinc-500"
                  }, [
                    _createElementVNode("path", { d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" })
                  ])
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[14] || (_cache[14] = _createElementVNode("label", {
                for: "email",
                class: "block text-sm font-medium text-zinc-200"
              }, "Email", -1)),
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  id: "email",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((email).value = $event)),
                  type: "email",
                  required: "",
                  class: "w-full px-4 py-3 bg-white/5 rounded-md text-white placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-[#10B981] focus:border-[#10B981] transition-all duration-200",
                  placeholder: "seu@email.com"
                }, null, 512), [
                  [_vModelText, email.value]
                ]),
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none" }, [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "18",
                    height: "18",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    class: "text-zinc-500"
                  }, [
                    _createElementVNode("rect", {
                      width: "20",
                      height: "16",
                      x: "2",
                      y: "4",
                      rx: "2"
                    }),
                    _createElementVNode("path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" })
                  ])
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[17] || (_cache[17] = _createElementVNode("label", {
                for: "password",
                class: "block text-sm font-medium text-zinc-200"
              }, "Senha", -1)),
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  id: "password",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((password).value = $event)),
                  type: showPassword.value ? 'text' : 'password',
                  required: "",
                  class: "w-full px-4 py-3 bg-white/5 rounded-md text-white placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-[#10B981] focus:border-[#10B981] transition-all duration-200",
                  placeholder: "••••••••"
                }, null, 8, _hoisted_15), [
                  [_vModelDynamic, password.value]
                ]),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (showPassword.value = !showPassword.value)),
                  class: "absolute inset-y-0 right-0 flex items-center pr-3 text-zinc-500 hover:text-zinc-300 transition-colors"
                }, [
                  (!showPassword.value)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_16, _cache[15] || (_cache[15] = [
                        _createElementVNode("path", { d: "M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" }, null, -1),
                        _createElementVNode("circle", {
                          cx: "12",
                          cy: "12",
                          r: "3"
                        }, null, -1)
                      ])))
                    : (_openBlock(), _createElementBlock("svg", _hoisted_17, _cache[16] || (_cache[16] = [
                        _createElementVNode("path", { d: "M9.88 9.88a3 3 0 1 0 4.24 4.24" }, null, -1),
                        _createElementVNode("path", { d: "M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68" }, null, -1),
                        _createElementVNode("path", { d: "M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61" }, null, -1),
                        _createElementVNode("line", {
                          x1: "2",
                          x2: "22",
                          y1: "2",
                          y2: "22"
                        }, null, -1)
                      ])))
                ])
              ]),
              (password.value.length > 0 && password.value.length < 8)
                ? (_openBlock(), _createElementBlock("p", _hoisted_18, " A senha deve ter pelo menos 8 caracteres "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _withDirectives(_createElementVNode("input", {
                  id: "terms",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((acceptTerms).value = $event)),
                  type: "checkbox",
                  required: "",
                  class: "peer sr-only"
                }, null, 512), [
                  [_vModelCheckbox, acceptTerms.value]
                ]),
                _createElementVNode("label", _hoisted_21, [
                  (acceptTerms.value)
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_22, _cache[18] || (_cache[18] = [
                        _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                      ])))
                    : _createCommentVNode("", true)
                ])
              ]),
              _cache[19] || (_cache[19] = _createElementVNode("div", { class: "ml-3 text-sm" }, [
                _createElementVNode("label", {
                  for: "terms",
                  class: "text-zinc-400 cursor-pointer leading-relaxed"
                }, [
                  _createTextVNode(" Eu concordo com os "),
                  _createElementVNode("a", {
                    href: "https://ajuda.hoopay.com.br/terms-of-services",
                    target: "_blank",
                    class: "text-[#10B981] hover:text-[#0EA271] font-medium"
                  }, "Termos de Serviço"),
                  _createTextVNode(" e "),
                  _createElementVNode("a", {
                    href: "https://ajuda.hoopay.com.br/privacy",
                    target: "_blank",
                    class: "text-[#10B981] hover:text-[#0EA271] font-medium"
                  }, "Política de Privacidade")
                ])
              ], -1))
            ]),
            _createElementVNode("button", {
              type: "submit",
              disabled: isDisabled.value,
              class: _normalizeClass([
                'w-full py-3 px-4 font-medium rounded-md transition-colors duration-200 flex items-center justify-center',
                !isDisabled.value
                  ? 'bg-[#10B981] hover:bg-[#0EA271] text-white' 
                  : 'bg-zinc-800 text-zinc-500 cursor-not-allowed'
              ])
            }, [
              (isLoading.value)
                ? (_openBlock(), _createBlock(_unref(Loader2), {
                    key: 0,
                    class: "w-4 h-4 animate-spin mr-2"
                  }))
                : _createCommentVNode("", true),
              _cache[20] || (_cache[20] = _createElementVNode("span", null, "Criar conta", -1)),
              _cache[21] || (_cache[21] = _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "18",
                height: "18",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                class: "ml-2"
              }, [
                _createElementVNode("path", { d: "M5 12h14" }),
                _createElementVNode("path", { d: "m12 5 7 7-7 7" })
              ], -1))
            ], 10, _hoisted_23)
          ], 32),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("p", _hoisted_25, [
              _cache[23] || (_cache[23] = _createTextVNode(" Já tem uma conta? ")),
              _createVNode(_component_RouterLink, {
                to: "/login",
                class: "text-[#10B981] hover:text-[#0EA271] font-medium ml-1 transition-colors"
              }, {
                default: _withCtx(() => _cache[22] || (_cache[22] = [
                  _createTextVNode(" Fazer login ")
                ])),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})